import fieldDataClient from "../../api/digitalTwin/fieldDataClient";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchPlantsFailure,
  fetchPlantsStart,
  fetchPlantsSuccess,
} from "../../store/features/digitalTwin/plantsSlice";

const URL = "/plants/";

const getPlants = async (field_id) => {
  try {
    const response = await fieldDataClient.get(`${URL}?field_id=${field_id}`);
    console.log("here", response);
    return response.data;
  } catch (error) {
    console.log("here error", error);
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* fetchPlantsSaga(action) {
  try {
    const { field_id } = action.payload;
    const plantsData = yield call(getPlants, field_id);
    yield put(fetchPlantsSuccess(plantsData));
  } catch (error) {
    yield put(fetchPlantsFailure(error.message));
  }
}

export default function* plantsSaga() {
  yield takeLatest(fetchPlantsStart.type, fetchPlantsSaga);
}
